import {
  ChatDetailsView,
  TextPageView,
  GoogledLyricsDetailsView,
  YouTubePageView,
} from "./api-generated";

export const AUTH_TOKEN_KEY = "token";

//TODO: can I get this from openapi spec???
export type SourceDetailsView =
  | YouTubePageView
  | TextPageView
  | GoogledLyricsDetailsView
  | ChatDetailsView;
